module.exports = __webpack_public_path__ + "img/m9.0f77045e.jpg";